import {
	ClickerCommand,
	ScriptMove,
	ScriptPosition,
	scriptMoveFor,
} from './clicker'
import { useClicker } from './use-clicker'

type Options = {
	enabled: boolean
	position: ScriptPosition
	/** Changes whenever the server has moved the script or confirmed a step. */
	stepKey: string
	move: (move: ScriptMove) => Promise<unknown>
}

/**
 * The trainer's presentation clicker, walking the agenda: each press makes
 * the move `scriptMoveFor` gives from where the script is, one step at a
 * time (`useClicker`). Returns the command just pressed, for the agenda bar
 * to light its arrow.
 */
export const useScriptClicker = ({
	enabled,
	position,
	stepKey,
	move,
}: Options): ClickerCommand | undefined =>
	useClicker({
		enabled,
		stepKey,
		act: command => {
			const scriptMove = scriptMoveFor(command, position)
			return scriptMove ? move(scriptMove) : undefined
		},
	})

export default useScriptClicker
